import Logo from '@/components/logo';
import { getPrivacy } from '@/lib/api';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';
import { useEffect, useState } from 'react';

interface PrivacyData {
  id: number;
  title: string;
  body: string;
  createdAt: string;
  updatedAt: string;
}

const cleanHtmlContent = (html: string): string => {
  return html.replace(/style="color:\s*rgb\(0,\s*0,\s*0\)"/g, '');
};
export const Route = createFileRoute('/privacy')({
  component: RouteComponent,
});

function RouteComponent() {
  const [privacy, setPrivacy] = useState<PrivacyData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchRules = async () => {
      try {
        const data = await getPrivacy();
        setPrivacy(data);
      } catch (err) {
        setError('Nem sikerült betölteni a szabályzatot.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchRules();
  }, []);

  if (isLoading) {
    return (
      <div className="flex h-[50vh] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-[50vh] items-center justify-center">
        <p className="text-lg text-red-500">{error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col justify-between">
      <div className="bg-hero bg-cover bg-center flex items-center justify-center py-20 pt-40">
        <h1 className="text-center text-3xl xl:text-5xl font-bold text-white font-heineken">
          {privacy?.title}
        </h1>
      </div>

      <div className="container mx-auto max-w-5xl px-4 py-8 pt-20">
        <div
          className="prose prose-lg !max-w-none [&_ul]:!list-disc [&_ul]:!ml-3 [&_ul]:!mb-4 [&_ol]:!list-decimal [&_ol]:!ml-3 [&_ol]:!mb-4 [&_ul_li]:!ml-3 [&_ol_li]:!ml-3 [&_ul_li]:!pl-2 [&_ol_li]:!pl-2 [&_p]:!my-4 [&_p]:first:!mt-0 [&_p]:last:!mb-0 [&_p]:!text-base [&_p]:!leading-relaxed [&_h1]:!text-heineken-green [&_h1]:!font-heineken [&_h1]:!text-4xl !mx-auto"
          dangerouslySetInnerHTML={{
            __html: privacy?.body ? cleanHtmlContent(privacy.body) : '',
          }}
        />
      </div>

      <footer className=" text-white bg-gradient-to-r from-heineken-dark-green via-heineken-light-green to-heineken-green py-10 px-4 md:px-0">
        <div className="container mx-auto ">
          <div className="flex flex-col items-center mt-10">
            <Logo />

            <p className="text-base text-white uppercase mt-4">
              HA KÉRDÉSED VAN, ÍRJ NEKÜNK A{' '}
              <a href="mailto:liga@solidagency.hu" className="hover:underline">
                LIGA@SOLIDAGENCY.HU
              </a>{' '}
              E-MAIL CÍMRE!
            </p>

            <a
              href="https://www.heineken.com/hu/hu/fogyaszd-felelosseggel"
              className="bg-white text-heineken-green font-bold mx-auto mt-4 px-4 py-2 cursor-pointer"
              target="_blank"
            >
              Fogyaszd felelősséggel
            </a>

            <nav className="mb-6 md:mt-10">
              <ul className="flex flex-row gap-2 text-xs">
                <li>
                  <Link to="/privacy" className="hover:underline">
                    Adatvédelmi Tájékoztató
                  </Link>
                </li>
                <li>
                  <Link to="/rules" className="hover:underline">
                    Játékszabály
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </footer>
    </div>
  );
}
